<template>
    <div class="content-window-container"
         v-observe-visibility="visibilityChanged"
         :id="pageID">
        <div class="container">
            <div class="window-title will-animate"
                 data-ani="animated fadeInDown">{{$t('Page.AboutUs.Title')}}</div>

            <!--<div class="team clear will-animate" data-ani="animated fadeInDown">-->
                <!--<div class="team-member" v-for="(m, idx) in teamInfo" :key="idx">-->
                    <!--<div class="avatar">-->
                        <!--<img :src="m.Avatar"/>-->
                    <!--</div>-->
                    <!--<div class="text">-->
                        <!--<div class="name" v-text="m.Name"></div>-->
                        <!--<div class="title" v-text="m.Title"></div>-->
                    <!--</div>-->

                <!--</div>-->
            <!--</div>-->
            <div class="window-subtitle will-animate"
                 data-ani="animated fadeInUp">
                {{$t('Page.AboutUs.Content')}}
            </div>
            <div class="window-content will-animate" data-ani="animated fadeInUp">
                <div class="out-links">
                    <div>
                        <a target="_blank" href="mailto:support@sealsc.com"><font-awesome-icon :icon="['fas', 'envelope']"/></a>
                    </div>
                    <div>
                        <a target="_blank" href="https://twitter.com/SealSC_Cloud"><font-awesome-icon :icon="['fab', 'twitter']"/></a>
                    </div>
                    <div>
                        <a target="_blank" href="https://t.me/sealsc"><font-awesome-icon :icon="['fab', 'telegram-plane']"/></a>
                    </div>
                    <div>
                        <a target="_blank" href="https://github.com/SealSC"><font-awesome-icon :icon="['fab', 'github']"/></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {pageMounted, basicPageMethods} from "../js/common"
  import {scNamespace} from "../js/scNamespace"

  export default {
    name: "about-us",
    mounted: pageMounted,
    data() {
      return {
        pageID: scNamespace.PAGE.ABOUT_US.id
      }
    },
    computed: {
      teamInfo() {
        return this.$t('Page.AboutUs.Team')
      }
    },
    methods: {
      ...basicPageMethods(),
    }
  }
</script>

<style scoped>
    .content-window-container {
        z-index: 20000;
    }

    .container {
        /*min-height: 600px !important;*/
    }
    .window-content {
        display: flex;
        width: 100%;
        justify-content:center;
        flex-direction: row;
    }

    .window-content > div {
        display: flex;
        width: 100%;
        justify-content:center;
        flex-direction: row;
    }

    .window-subtitle {
        padding: 20px 160px;
        text-align: center;
    }


    .window-content > div > div > a,
    .window-content > div > div > a:hover,
    .window-content > div > div > a:active {
        font-size: 24px;
        text-decoration: none;
        color: #2c3e50;
        cursor: pointer;
    }

    .window-content > div > div > a {
        display: block;
        width: 40px;
        height: 40px;
        line-height: 48px;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 20px;
        transition: all 0.2s;
    }

    .window-content > div > div > a > svg {
        width: 40px;
        height: 40px;
        border: 8px solid transparent;
        transition: all 0.2s;
    }
    .window-content > div > div > a:hover {
        background-color: #eff4f7;
    }
    .window-content > div > div > a:hover > svg {
        border: 6px solid #eff4f7;
    }

    /*.team {*/
        /*padding: 20px 100px;*/
        /*margin-bottom: 10px;*/
    /*}*/

    /*.team > div  {*/
        /*float: left;*/
        /*width: 20%;*/
    /*}*/

    /*.team > div img {*/
        /*width: 56px;*/
        /*border-radius: 50%;*/
    /*}*/

    /*.window-content > div.out-links {*/
        /*margin-top: 20px;*/
    /*}*/

    /*.team > div.team-member > div {*/
        /*margin-bottom: 16px;*/
        /*text-align: center;*/
    /*}*/

    /*.team > div.team-member > div.avatar {*/
        /*margin-right: 10px;*/
    /*}*/
    /*.team > div.team-member div.text > div.name,*/
    /*.team > div.team-member div.text > div.title {*/
        /*font-size: 14px;*/
        /*padding-top: 8px;*/
    /*}*/
    /*.team > div.team-member div.text > div.name {*/
        /*font-size: 16px;*/
    /*}*/
    /*.team > div.team-member div.text > div.title {*/
        /*font-size: 14px;*/
        /*font-weight: 300;*/
    /*}*/
</style>

<style scoped>
    @media screen and (max-width: 720px) {
        .container {
            min-height: auto !important;
        }

        .window-content > div {
            display: block;
            width: 100%;
            justify-content:center;
        }

        .window-subtitle {
            padding: 0;
            text-align: center;
            margin-bottom: 20px;
        }

        .team {
            display: none;
        }

        .window-content > div.out-links {
            text-align: center;
            margin-top: 0;
        }

        .window-content > div.out-links > div {
            display: inline-block;
        }

        .window-content > div > div > a {
            margin: 0 10px;
        }

        /*.window-title.md-display-1 {*/
            /*padding: 0 20px;*/
            /*font-size: 24px !important;*/
            /*!*margin-top: -100px;*!*/
        /*}*/
        /*.window-content {*/
            /*display: block;*/
            /*width: 100%;*/
        /*}*/

        /*.window-content.md-subheading {*/
            /*margin-bottom: 60px;*/
            /*font-size: 16px;*/
            /*padding: 0 20px;*/
        /*}*/

        /*.window-content > div {*/
            /*padding: 0 20px;*/
            /*margin-top: 40px;*/
        /*}*/

        /*.window-subtitle {*/
            /*padding: 0 20px;*/
        /*}*/

        /*.team {*/
            /*padding-left: 20px;*/
        /*}*/

        /*.team > div {*/
            /*width: 160px;*/
        /*}*/
        /*.team > div img {*/
            /*width: 28px;*/
        /*}*/

        /*.team > div.team-member > div.avatar {*/
            /*margin-right: 6px;*/
        /*}*/
        /*.team > div.team-member div.text > div.name,*/
        /*.team > div.team-member div.text > div.title {*/
            /*font-size: 12px;*/
            /*height: 16px;*/
            /*line-height: 12px;*/
            /*padding-top: 0;*/
        /*}*/
    }
</style>